import React from 'react'
import { Grid, ListItemIcon, MenuItem, Typography } from '@mui/material'
import callIcon from 'assets/images/customerCall.svg'

function CustomerEmergency(props) {
  const details = props?.details?.EmergencyContacts
  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      className="customerAbout height273"
      sm={12}
    >
      <Grid item
      >

        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className="fontBold font16 paddingTopBottom10" variant="h4">
            Emergency Contact
          </Typography>

        </Grid>

      </Grid>
      {details?.map((val, idx) => (
        (props?.first3 && idx<3 && <Grid item className='mb10'>
          <MenuItem className="mb10 subHeaderCard">
            <ListItemIcon>
              <img src={callIcon} alt="call icon" fontSize="small" />
            </ListItemIcon>
            <div className="font14 fontSemi marginInline">
              <p className='marginBlock0'>{val?.name}</p>
              <p className='colorGrey font12 paddingTop0 marginBlock0'>{val?.relation+" "+val?.mobile}</p>
            </div>
          </MenuItem>
        </Grid>)
      ))}
      {details?.map((val, idx) => (
        (props?.last2 && idx>2 && <Grid item className='mb10'>
          <MenuItem className="subHeaderCard mb10">
            <ListItemIcon>
              <img src={callIcon} alt="call icon" fontSize="small" />
            </ListItemIcon>
            <div className="font14 fontSemi marginInline">
              <p className='marginBlock0'>{val?.name}</p>
              <p className='colorGrey font12 paddingTop0 marginBlock0'>{val?.relation+" "+val?.mobile}</p>
            </div>
          </MenuItem>
        </Grid>)
      ))}
    </Grid>

  )
}

export default CustomerEmergency